import { jsxs as m, jsx as o, Fragment as q } from "react/jsx-runtime";
import { Field as G, ComboboxButton as H, ComboboxOption as J, ComboboxOptions as K } from "@headlessui/react";
import { useState as R, useEffect as U, useMemo as X } from "react";
import { twMerge as t } from "tailwind-merge";
import { FieldErrorAndDescription as Y } from "../form/field-error-and-description.mjs";
import { FieldLabel as Z } from "../form/field-label.mjs";
import { ArrowButton as _ } from "./components/arrow-button.mjs";
import { ComboboxMultiple as $ } from "./components/combobox-multiple.mjs";
import { FormSelectInput as v } from "./components/form-select-input.mjs";
import { ListOptions as P } from "./components/list-options.mjs";
import { useFilteredData as oo } from "./hooks/use-filtered-data.mjs";
import { getVirtualizedData as to } from "./utils/get-virtualized-data.mjs";
import { CloseButton as eo } from "./components/close-button.mjs";
import { useTranslation as ro } from "../../i18n/hooks.mjs";
function Do({
  label: g,
  data: l,
  staticData: a,
  onChange: c,
  labelClassName: F,
  value: e,
  isPreFetching: f,
  placeholder: B,
  error: d,
  required: D,
  description: w,
  className: O,
  containerClassName: y,
  closeButtonClassName: M,
  arrowButtonClassName: V,
  fieldClassName: j,
  disabled: A,
  withoutCloseIcon: E,
  onOpen: u,
  onClose: n,
  dataTest: S,
  wrapperProps: L,
  loaderClassName: so,
  loaderWrapperClassName: io,
  hideSelectedValues: k,
  inputWrapperClassName: z,
  inputRef: I,
  ...Q
}) {
  const { t: T } = ro(), [b, p] = R(!1);
  U(() => {
    b && u && (u(), p(!1));
  }, [b]);
  const x = X(
    () => {
      var s;
      return ((s = l ?? a) == null ? void 0 : s.filter((i) => e == null ? void 0 : e.includes(i.id))) ?? [];
    },
    [l, a, e]
  ), { filteredData: h, setQuery: C } = oo(l), N = e.length > 0, r = A || f || N && (!l && !a), W = N && !E && !r;
  return /* @__PURE__ */ m("div", { className: t("relative flex flex-col gap-1", y), children: [
    /* @__PURE__ */ o(
      $,
      {
        selectedData: x,
        virtual: to(h, T),
        onChange: c,
        disabled: r,
        onClose: () => {
          C(""), n == null || n();
        },
        children: (s) => /* @__PURE__ */ m(q, { children: [
          /* @__PURE__ */ m(G, { className: t("flex flex-col gap-1", j), children: [
            /* @__PURE__ */ o(
              Z,
              {
                wrapperAs: "label",
                wrapperProps: L,
                label: g,
                required: D,
                labelClassName: t("text-sm font-medium", F)
              }
            ),
            /* @__PURE__ */ m(H, { as: "div", className: t("relative", z), children: [
              /* @__PURE__ */ o(
                v,
                {
                  dataTest: S,
                  inputRef: I,
                  isDisabled: r,
                  hasError: !!d,
                  open: s,
                  className: O,
                  placeholder: B,
                  isPreFetching: f,
                  selectedCaption: k ? "" : x.map((i) => i.caption).join(", "),
                  onFocus: () => p(!0),
                  onChange: (i) => {
                    p(!0), C(i);
                  }
                }
              ),
              /* @__PURE__ */ o(
                _,
                {
                  isDisabled: r,
                  arrowButtonClassName: t(
                    "absolute inset-y-0 right-4 h-[46px] sm:h-[42px]",
                    V
                  ),
                  open: s
                }
              )
            ] }),
            W && /* @__PURE__ */ o(
              eo,
              {
                isDisabled: r,
                closeButtonClassName: t(
                  "absolute bottom-0 right-10 h-[46px] sm:h-[42px]",
                  M
                ),
                onClick: () => c([])
              }
            )
          ] }),
          /* @__PURE__ */ o(
            P,
            {
              asOptions: K,
              asOption: J,
              data: h,
              ...Q
            }
          )
        ] })
      }
    ),
    /* @__PURE__ */ o(Y, { error: d, description: w })
  ] });
}
export {
  Do as FormSelectMultiple
};
